import { REFINED, SymbolSVG, Word, LockupRow } from "@/brand/refined";
import { IMAGES } from "@/data/images";

const IVORY = "#F7F5F0", INK = "#1A1C1E", FOREST = "#2D3B32", STONE = "#C8C2B7";

const Cap = ({ children }) => <p className="font-mono-ss text-[9px] tracking-[0.2em] uppercase opacity-50 mt-3">{children}</p>;

const Header = ({ c, mobile }) => (
  <div style={{ background: IVORY, borderBottom: `1px solid #E2DDD5`, width: mobile ? 300 : "100%" }} className="flex items-center justify-between px-5 py-4">
    {mobile ? <SymbolSVG c={c} size={22} bg={IVORY} /> : <LockupRow c={c} height={13} bg={IVORY} />}
    {!mobile && (
      <div className="flex items-center gap-6 text-[10px] tracking-[0.06em]" style={{ color: INK }}>
        <span>Intelligence</span><span>Locations</span><span>Journal</span><span>Land &amp; Law</span>
        <span className="border px-3 py-1.5 uppercase text-[8px] tracking-[0.12em]" style={{ borderColor: INK }}>Discuss a Property</span>
      </div>
    )}
    {mobile && <div className="flex flex-col gap-1"><span className="block h-px w-4" style={{ background: INK }} /><span className="block h-px w-4" style={{ background: INK }} /></div>}
  </div>
);

const Tab = ({ c }) => (
  <div style={{ background: "#DEE1E6" }} className="px-3 pt-2">
    <div style={{ background: "#fff" }} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-t-md">
      <SymbolSVG c={c} size={16} bg="#fff" />
      <span className="text-[10px]" style={{ color: "#333" }}>Selling Sunsets — Property Intelligence</span>
    </div>
  </div>
);

const AppIcon = ({ c, round }) => (
  <div style={{ width: 84, height: 84, background: round ? INK : FOREST, borderRadius: round ? 999 : 18, color: IVORY }} className="flex items-center justify-center">
    <SymbolSVG c={c} size={46} bg={round ? INK : FOREST} />
  </div>
);

const Report = ({ c }) => (
  <div style={{ width: 190, height: 268, background: INK, color: IVORY }} className="p-5 flex flex-col justify-between">
    <LockupRow c={c} height={9} bg={INK} />
    <div>
      <p className="font-mono-ss text-[7px] tracking-[0.2em] uppercase opacity-50">Property Intelligence Report · 02 / 2026</p>
      <p className="font-display text-[20px] leading-[1.05] mt-2">Mukteshwar — land, law, location.</p>
      <div className="h-px my-3" style={{ background: "rgba(247,245,240,0.2)" }} />
      <p className="text-[7px] tracking-[0.12em] uppercase opacity-60">Property Intelligence &amp; Advisory</p>
    </div>
  </div>
);

const Card = ({ c }) => (
  <div style={{ width: 232, height: 150, background: IVORY, color: INK, border: "1px solid #E2DDD5" }} className="p-4 flex flex-col justify-between">
    <SymbolSVG c={c} size={22} bg={IVORY} />
    <div>
      <p className="font-display text-[13px]">Suhail Abbas Zaidi</p>
      <p className="font-mono-ss text-[6.5px] tracking-[0.18em] uppercase opacity-60 mt-0.5">Founder · Selling Sunsets</p>
      <p className="text-[7px] mt-2 opacity-70">hi@sellingsunsets.co.in · sellingsunsets.co.in</p>
    </div>
  </div>
);

const Masthead = ({ c }) => (
  <div style={{ background: "#fff", color: INK, borderBottom: `1px solid #E2DDD5` }} className="w-full px-5 py-3 flex items-center justify-between">
    <Word c={c} height={9} />
    <p className="font-mono-ss text-[7px] tracking-[0.2em] uppercase opacity-50">Property intelligence document · Ref. SS-2026-014 · Page 3 / 18</p>
  </div>
);

const Watermark = ({ c }) => (
  <div className="relative overflow-hidden" style={{ width: 232, height: 150 }}>
    <img src={IMAGES.valleyMist.thumb} alt="" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute bottom-3 right-3" style={{ color: IVORY, opacity: 0.75 }}>
      <SymbolSVG c={c} size={24} bg="transparent" />
    </div>
  </div>
);

const Variant = ({ label, children }) => (
  <div className="flex flex-col items-start gap-2">
    <div className="flex items-center h-10">{children}</div>
    <Cap>{label}</Cap>
  </div>
);

const Candidate = ({ c, i }) => (
  <section className="border-t border-black/15 pt-10" data-testid={`refined-${c.key}`}>
    <div className="grid grid-cols-12 gap-8">
      <div className="col-span-12 lg:col-span-3">
        <p className="font-mono-ss text-[11px] tracking-[0.22em] opacity-50">R{i + 1}</p>
        <h3 className="font-display text-4xl font-light mt-2">{c.name}</h3>
        <p className="text-[0.85rem] opacity-70 leading-relaxed mt-4">{c.rationale}</p>
        <div className="mt-8 p-6" style={{ background: "#fff", border: "1px solid #E4E4E4" }}>
          <Cap>Responsive system</Cap>
          <div className="mt-4 space-y-5" style={{ color: INK }}>
            <Variant label="Primary · symbol + wordmark"><LockupRow c={c} height={16} bg="#fff" /></Variant>
            <Variant label="Editorial · wordmark only"><Word c={c} height={16} /></Variant>
            <Variant label="Compact · symbol / SS">
              <svg viewBox={c.compactViewBox} height={30} style={{ display: "block" }}><c.Compact bg="#fff" /></svg>
            </Variant>
            <Variant label="Micro · symbol only"><SymbolSVG c={c} size={20} bg="#fff" /></Variant>
          </div>
        </div>
      </div>

      <div className="col-span-12 lg:col-span-9 space-y-6">
        <div>
          <Header c={c} />
          <Cap>Website header · 1440</Cap>
        </div>
        <div className="flex flex-wrap gap-10 items-start">
          <div><Header c={c} mobile /><Cap>Mobile header · 375</Cap></div>
          <div><Tab c={c} /><Cap>Favicon · 16px in a browser tab</Cap></div>
          <div><AppIcon c={c} /><Cap>App icon</Cap></div>
          <div><AppIcon c={c} round /><Cap>Instagram avatar</Cap></div>
        </div>
        <div className="flex flex-wrap gap-10 items-start">
          <div><Report c={c} /><Cap>Research report cover</Cap></div>
          <div className="space-y-6">
            <div><Card c={c} /><Cap>Business card · 85 × 55</Cap></div>
            <div><Watermark c={c} /><Cap>Photography watermark</Cap></div>
          </div>
          <div className="flex-1 min-w-[300px]"><Masthead c={c} /><Cap>Property intelligence document masthead</Cap></div>
        </div>
      </div>
    </div>
  </section>
);

export const BrandRefinement = () => (
  <>
    <section className="mt-28" data-testid="refinement">
      <p className="font-mono-ss text-[11px] tracking-[0.22em] uppercase opacity-50">Stage 03 · Refinement</p>
      <h2 className="font-display text-4xl font-light mt-3 mb-12">Three directions, refined and tested in application</h2>
      <div className="space-y-16">
        {REFINED.map((c, i) => <Candidate key={c.key} c={c} i={i} />)}
      </div>
    </section>

    <section className="mt-28 max-w-3xl" data-testid="recommendation">
      <p className="font-mono-ss text-[11px] tracking-[0.22em] uppercase opacity-50">Stage 04 · Recommendation</p>
      <h2 className="font-display text-4xl font-light mt-3 mb-6">Horizon, with Section held in reserve.</h2>
      <div className="text-[0.95rem] leading-relaxed opacity-80 space-y-4">
        <p>
          <strong>Horizon</strong> carries the most meaning with the least material: one letter, one cut, one displacement. It is the only direction whose wordmark and symbol are the same device — the cut initials in SELLING SUNSETS <em>are</em> the symbol — so recognition compounds everywhere the name appears. It survives 16px, works in solid black, and has no reading as mountain, sun, house or map.
        </p>
        <p>
          <strong>Section</strong> is the most intellectually loaded (land law, index, doubled initial) and the most ownable as a standalone glyph, but it depends on an interlock that needs ≥ 20px to read cleanly; it is the stronger candidate if the symbol will mostly live at app-icon size and larger.
        </p>
        <p>
          <strong>Parcel</strong> is quiet and credible but its frame is a shared device; it would be the safest, not the most distinctive, choice.
        </p>
      </div>
    </section>
  </>
);

export default BrandRefinement;
